import React, { Component } from 'react';
import { Table, Drawer, Select} from 'antd';
import {orderBy} from "lodash";
import DataTable from '../Component/Datatable';
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import AddFranchise from '../Component/AddFranchise';
import EditFranchise from '../Component/EditFranchise';
import Loader from '../../../Common/Component/Loader';
import {errorHandle} from "../../../Common/errorHandle";

const {Option} = Select;
class FranchiseList extends Component {

  state = {
    franchiseData: [],
    franchiseList: {},
    filterData: {
      franchise: 'all',
      /*active: false,
        inactive: false,
        filterFranchise: '',
        joined: [],
        lastService: [],
        outstanding: [],
        satisfaction: ''*/
    },
    franchise_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    active_pagination: '15',
    visible: false,
    delete_id: '',
    isNav: '',
    is_add_franchise: false,
    is_edit_franchise: false,
    openNav: false,
    loader: false,
    isQuickbooksCallback: false,
    is_crud_allow: true,
    is_add_new_franchise: true,
  }

  componentDidMount = () => {
    localStorage.removeItem('temp_franchise');
    //////////////////////
    this.props.getFranchise();
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role})
    /////////////////////
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";

    const user = JSON.parse(localStorage.getItem("authUser"))
    if (accessToken) {
      //get filed office list
      this.props.getFieldOffice({ limit: 15, offset: 0 });
      this.setState({
        loader: true
      })

    }
    else {
      window.location.assign('/')
      localStorage.clear();
      sessionStorage.clear();
    }


    if (user.user?.role.includes('business_dev_franchiese') || user.user?.role.includes('accounting_franchiese') || user.user?.role.includes('service_rep') || user.user?.role.includes('operations_mgr')) {
      this.setState({
        is_crud_allow: false,
        is_add_new_franchise: false
      })
    }
    if (user.user?.role.includes('franchise_owner')) {
      this.setState({ is_add_new_franchise: false })
    }

  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { franchise_pagination } = this.state;

    if (Object.keys(props?.QuickbookLogin?.loginCallbackData).length > 0 && props.QuickbookLogin.loginCallbackData !== this.props.QuickbookLogin.loginCallbackData) {
      this.setState({
        loader: false
      })
      localStorage.setItem('temp_franchise', JSON.stringify({ 'data': props.QuickbookLogin.loginCallbackData }))
      this.props.history.push('/franchise/detail', { query: { 'data': props.QuickbookLogin.loginCallbackData } });
    }

    if (Object.keys(props.QuickbookLogin.errors).length > 0 && props.QuickbookLogin.errors !== this.props.QuickbookLogin.errors) {
      errorHandle(props?.QuickbookLogin?.errors)
      this.setState({
        loader: false,
      })
    }


    //get Field Office
    if (Object.keys(props.FieldOffice.data).length > 0 && props.FieldOffice.data !== this.props.FieldOffice.data) {
      franchise_pagination.total = props.FieldOffice.data.count
      this.setState({
        loader: false,
        franchiseData: props.FieldOffice.data.results
      })
    }

    //get Franchise List
    if (Object.keys(props?.Settings?.franchise).length > 0 && JSON.stringify(props?.Settings?.franchise) !== JSON.stringify(this.prop?.Settings?.franchise)) {
      this.setState({franchiseList: props?.Settings?.franchise});
    }

    if (Object.keys(props.FieldOffice.errors).length > 0 && props.FieldOffice.errors !== this.props.FieldOffice.errors) {
      errorHandle(props?.FieldOffice?.errors)
      this.setState({
        loader: false,
      })
    }

    //Close Franchise
    if (Object.keys(props.CloseFranchise.data).length > 0 && props.CloseFranchise.data !== this.props.CloseFranchise.data) {
      //get filed office list
      this.props.getFieldOffice({ limit: 15, offset: (franchise_pagination.current * 15) - 15 });
      // get Franchise List
      this.props.getFranchiseList();

    }

    if (Object.keys(props.CloseFranchise.errors).length > 0 && props.CloseFranchise.errors !== this.props.CloseFranchise.errors) {
      errorHandle(props?.CloseFranchise?.errors)
      this.setState({
        loader: false,
      })
    }

  }

  //////////////////////////
  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr')
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const is_corporate = logged_in_user_role?.includes('admin')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    return {is_franchise_owner, isCorporate: (is_corporate || is_account_franchise), franchise_uuid: franchise_uuid?.[0], is_disable_franchise_dropdown: (is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)}
  }
  /////////////////////////

  // Render Franchise Table
  renderFranchiseTable = () => {
    let { franchise_pagination, active_pagination, franchiseData, } = this.state;
    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          dataSource={franchiseData}
          pagination={franchise_pagination}
          onChange={this.onFranchiseHandelChange}
          columns={DataTable.AllFranchiseList(this)}
          onRow={(record) => {
            return {
              onClick: () => {
                localStorage.setItem('temp_franchise', JSON.stringify({ 'data': record }))
                this.props.history.push(`/franchise/detail`, { query: { 'data': record } })
                console.log("data", franchiseData)
              }
            }
          }}
          className="table hscroll"
        />
        <ul className="pagination_page_size">
          <li>
            <span>Show:</span>
          </li>
          <li>
            <span
              onClick={() => { this.setUserPageLimit('15') }}
              className={active_pagination === '15' ? 'active' : ''}
            >15</span>
          </li>
          <li>
            <span
              className={active_pagination === '30' ? 'active' : ''}
              onClick={() => { this.setUserPageLimit('30') }}>30</span>
          </li>
          <li>
            <span
              className={active_pagination === '60' ? 'active' : ''}
              onClick={() => { this.setUserPageLimit('60') }}>60</span>
          </li>
        </ul>
      </React.Fragment>
    )
  }

  //set page limit
  setUserPageLimit = (custom_limit) => {
    let { franchise_pagination, search_value } = this.state;
    franchise_pagination = Object.assign(franchise_pagination, { 'current': 1, 'pageSize': custom_limit });


    this.setState({
      franchise_pagination,
      active_pagination: custom_limit,
      loader: true
    })
    let data = {
      offset: 0, limit: custom_limit, ordering: '', search: search_value,uuid: this.state.filterData?.franchise==='all'?"":this.state.filterData?.franchise
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getFieldOffice(data);
  }


  //Table Pagination and Ordering
  onFranchiseHandelChange = (pagination, filters, sorter) => {
    let { franchise_pagination, active_pagination, search_value } = this.state;

    franchise_pagination = Object.assign(franchise_pagination, { 'current': pagination.current });

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    }
    else {
      ordering = ''
    }

    let data = {
      offset: (pagination.current * 15) - 15,
      limit: active_pagination,
      ordering,
      search: search_value,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getFieldOffice(data)


    this.setState({
      franchise_pagination,
      loader: true
    })
  }

  // Show Table Nav
  ShowNav = (record,) => {
    if (!this.state.openNav) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      openNav: !prevState.openNav,
      isNav: record.uuid
    }));
  }

  // hide list toggle button
  handleOutsideClick = (e) => {
    // ignore clicks on the Component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }


    this.ShowNav({ 'uuid': '' }, '');
  }

  //Close drawer
  closeAddDrawer = (type) => {
    this.setState({
      is_add_franchise: type
    })
  }

  //Close drawer
  closeEditDrawer = (type) => {
    this.setState({
      is_edit_franchise: type
    })
  }



  // Search Ticket
  searchTicket = (e) => {
    if (e.target.value?.length >= 3 || e.target.value?.length === 0) {
      this.props.getFieldOffice({ 'search': e.target.value, 'offset': 0, 'limit': 15 });
    }

    this.setState({
      search_value: e.target.value
    })
  }

  leadingZeros = (value, size) => {
    let s = String(value);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  // on filter change
  onFilterChange = (e, type) => {
    const {filterData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterData, {[e.target.name]: value});
    this.setState({filterData: {...filterData}});
    if (filterData?.franchise && filterData?.franchise !== 'all') {
      this.setState({loader: true})
      this.props.getFieldOffice({uuid: filterData?.franchise})
    } else if (filterData?.franchise === 'all') {
      this.setState({loader: true})
      this.props.getFieldOffice()
    }
  }


  render() {
    let { is_add_franchise, is_edit_franchise, search_value, loader, is_add_new_franchise ,filterData, franchiseList} = this.state;
    const {is_disable_franchise_dropdown, franchise_uuid, isCorporate} = this.getLoggedInUserRole()
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder="ID & Name, Owner, Address"
            search_value={search_value}
            onSearch={(e) => { this.searchTicket(e) }}
            onEnter={(e) => e.target.value.length>=3?this.setState({search_value: '', loader: true}, () => this.searchTicket(e)):alert("Please type at least 3 character.")}
          />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />


          <div className="container">
            <div className="filter_wrapper">
              <div className="left_side">
                <Select
                  className="swhite"
                  placeholder="Select a Franchise"
                  name="franchise"
                  disabled={is_disable_franchise_dropdown}
                  onChange={(e) => this.onFilterChange({target: {name: 'franchise', value: e}}, '', 'franchise')}
                  value={filterData?.franchise || undefined}>
                  <Option key={'franchiseAll'} value={'all'}>{'All Franchises'}</Option>
                  {
                      orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{`${this.leadingZeros(option?.id, 3)} ${option?.name}`}</Option>)
                  }
                </Select>
                
              </div>
              <div className="right_side">
                <span className="ico-btn" ><i className="las la-filter"></i></span>
                <button
                  disabled={is_add_new_franchise ? false : true}
                  onClick={() => { this.closeAddDrawer(true) }}
                  className={is_add_new_franchise ? "btn btn-warning" : "btn btn-brand btn-bdr disbale_btn"}
                >Add New Franchise</button>
              </div>
            </div>
            <div>
            </div>

            <div className="data data-bottom-space">
              {this.renderFranchiseTable()}

              {/* Add Franchise Drawer */}
              <Drawer
                visible={is_add_franchise}
                width={'420'}
                closable={false}
                className="drawer-wrapper create_ticket_drawer"
              >
                <AddFranchise
                  closeAddDrawer={this.closeAddDrawer}
                  //Reducer
                  UserList={this.props.UserList}
                  FranchiseAdd={this.props.FranchiseAdd}
                  GoogleApi={this.props.GoogleApi}
                  // API Call
                  addFieldOffice={this.props.addFieldOffice}
                  getFieldOffice={this.props.getFieldOffice}
                  getFranchiseList={this.props.getFranchiseList}
                  getUserList={this.props.getUserList}
                  getGeocodeAddress={this.props.getGeocodeAddress}
                  resetGeocodeAddress={this.props.resetGeocodeAddress}
                />
              </Drawer>


              <Drawer
                visible={is_edit_franchise}
                width={'420'}
                closable={false}
                className="drawer-wrapper create_ticket_drawer"
              >
                <EditFranchise
                  closeEditDrawer={this.closeEditDrawer}
                  //Reducer
                  UserList={this.props.UserList}
                  EditFieldOffice={this.props.EditFieldOffice}
                  UpdateFranchise={this.props.UpdateFranchise}
                  Settings={this.props.Settings}
                  GoogleApi={this.props.GoogleApi}
                  // API Call
                  getFieldOffice={this.props.getFieldOffice}
                  getFranchiseList={this.props.getFranchiseList}
                  getUserList={this.props.getUserList}
                  updateFieldOffice={this.props.updateFieldOffice}
                  getUserDetail={this.props.getUserDetail}
                  getGeocodeAddress={this.props.getGeocodeAddress}
                  resetGeocodeAddress={this.props.resetGeocodeAddress}
                />
              </Drawer>

            </div>
          </div>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default FranchiseList;